import { render, staticRenderFns } from "./DdRadioGroup.vue?vue&type=template&id=2a7d8684&scoped=true&"
import script from "./DdRadioGroup.vue?vue&type=script&lang=js&"
export * from "./DdRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d8684",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRadioGroup,VRow})
